import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTermChipComponent } from "./ds-term-chip.component";

@NgModule({
  declarations: [DsTermChipComponent],
  imports: [CommonModule],
  exports: [DsTermChipComponent],
})
export class DsTermChipModule {}
